import React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import DataResults from '../assets/results_flex.svg';


const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    width:'50vw',
    height:'40vw',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};



function ResultsModal(props) {

  function getLabel(val){
    const parsed =val.split(":");
    return parsed[0];
  }

  function getResult(val){
    const parsed =val.split(":");
    return parsed[1];
  }


  return (
    <Container>

      <Modal
        isOpen={props.modalIsOpen}
        style={customStyles}
         ariaHideApp={false}
        contentLabel="Example Modal"
      >


        <ModalContainer>
            <h2>Flexibility Tool Results</h2>
            <Img src={DataResults}/>
            <P> <b>{getLabel(props.jsonData.totalVariance)} </b>: {getResult(props.jsonData.totalVariance)}</P>
            <P> <b>{getLabel(props.jsonData.averageVariance)} </b>: {getResult(props.jsonData.averageVariance)}</P>
            <P> <b>{getLabel(props.jsonData.res_3d_sd)} </b>: {getResult(props.jsonData.res_3d_sd)}</P>
              <Button color="#7eb35b" marginTop="20px" onClick={()=>props.closeModal()}> Ok </Button>

        </ModalContainer>



      </Modal>
    </Container>
  );
}




const Container = styled.div`
    font-family:'Fira Sans';
`;

const P = styled.p`
    font-family:'Fira Sans';
    width: 100%;
    margin-left: 300px;

`;
const Img =styled.img`
    height:200px;
    width:200px;
`;

const ModalContainer = styled.div`
    display: flex;
    justify-content:space-around;
    flex-direction:column;
    align-items:center;
    height:100%;


`;

const Button = styled.button`
		border: none;
		width: 200px;
		height:50px;
		margin-right:10px;
		color: #fff;
		background-color: ${props => props.color};
		font-size: 1.2em;
		transform-style: preserve-3d;
		outline: none;
		cursor: pointer;
		border-radius: 0.27em;
		text-align: center;
		font-family:'Fira Sans';
    box-shadow: 2px 4px 6px rgb(0 0 0 / 30%);
    margin-bottom:${props => props.marginBottom};
    margin-top:${props => props.marginTop};
`;


export default ResultsModal;



// WEBPACK FOOTER //
// ./src/components/resultsModal.js